import { LoanTag } from '../types/highlights'

export const defaultTags: LoanTag[] = [
  {
    id: 'tag-spousal',
    label: 'Spousal State',
    color: 'rose',
    visibility: 'condition',
    condition: { sourceFieldId: 'spousalState', operator: 'is_true' },
    description: 'Non-borrowing spouse must sign closing documents.',
    enabled: true,
  },
  {
    id: 'tag-witness',
    label: 'Witness State',
    color: 'orange',
    visibility: 'condition',
    condition: { sourceFieldId: 'witnessState', operator: 'is_true' },
    description: 'Closing requires a witness in addition to the notary.',
    enabled: true,
  },
  {
    id: 'tag-full-service',
    label: 'Full-Service Processing',
    color: 'emerald',
    visibility: 'condition',
    condition: { sourceFieldId: 'processingType', operator: 'eq', value: 'Full-Service' },
    enabled: true,
  },
  {
    id: 'tag-corr',
    label: 'CORR',
    color: 'teal',
    visibility: 'condition',
    condition: { sourceFieldId: 'channel', operator: 'eq', value: 'CORR' },
    description: 'Correspondent channel loan.',
    enabled: true,
  },
  {
    id: 'tag-ysp',
    label: 'YSP Comp',
    color: 'amber',
    visibility: 'condition',
    condition: { sourceFieldId: 'compensationType', operator: 'eq', value: 'YSP' },
    description: 'Lender-paid yield spread premium compensation.',
    enabled: true,
  },
  {
    id: 'tag-in-person',
    label: 'In Person',
    color: 'sky',
    visibility: 'condition',
    condition: { sourceFieldId: 'closingType', operator: 'eq', value: 'In Person' },
    description: 'Borrower is closing in person.',
    enabled: true,
  },
  {
    id: 'tag-non-qm',
    label: 'Non-QM',
    color: 'violet',
    visibility: 'condition',
    condition: { sourceFieldId: 'qmType', operator: 'eq', value: 'Non-QM' },
    description: 'Non-qualified mortgage — exception review required.',
    enabled: true,
  },
]
